export default "__VITE_ASSET__Bt72jZ6t__"